<template>
  <div>
    <b-row class="mb-3">
        <b-col sm="4">                
            <b-form-group>
                <label>Nombre</label>
                <b-form-input
                    v-model="filtroProductosComparados.buscar"
                    id="producto1_nombre"
                    name="producto1_nombre"
                    type="text"
                >
                </b-form-input>                    
            </b-form-group>                   
        </b-col>
        <b-col sm="4">                
            <b-form-group>
                <label>Fabricante</label>
                <el-select
                    v-model="filtroProductosComparados.id_fabricante"
                    id="id_fabricante"
                    name="id_fabricante"
                    filterable
                    clearable
                    no-data-text="No hay datos que coincidan"
                    no-match-text="No hay datos que coincidan"
                >
                    <el-option
                        v-for="fabricante in fabricantes"
                        :key="fabricante.id"
                        :label="fabricante.nombre"
                        :value="fabricante.id"
                    >
                    </el-option>
                </el-select>
            </b-form-group>                    
        </b-col>
        <b-col sm="4">
            <b-form-group>
                <label>Estado</label>
                <el-select
                    v-model="filtroProductosComparados.id_estado"
                    id="id_estado"
                    name="id_estado"
                    filterable
                    clearable   
                    no-data-text="No hay datos que coincidan"
                    no-match-text="No hay datos que coincidan"
                >
                    <el-option
                        v-for="item in estados"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </b-form-group>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="6">                
            <b-button variant="primary" @click="buscarProductosComparados">
                <i class="fa fa-search fa-lg"></i>
                Buscar
            </b-button>
            <b-button class="ml-5" variant="danger" @click="resetFiltros">
                <i class="fa fa-eraser fa-lg"></i> 
                Limpiar
            </b-button>
        </b-col>            
    </b-row>
    <b-row>
        <b-col>
            <b-button variant="primary" class="float-right mb-4" :disabled="productosGenerarMatriz.length < 2" @click="generarMatrizDescargable">
                Generar Matriz
            </b-button>
        </b-col>
    </b-row>
    <b-table
        responsive
        hover
        striped
        :fields="columnas"
        :items="productosComparados"
    >
       <template v-slot:cell(opciones)="data">
           <el-checkbox v-model="data.item.checked" @change="asignarProductoMatriz(data.item, $event)" />
       </template>
    </b-table>
    <el-pagination
        @size-change="setPerPagePagination"
        @current-change="setPagePagination"
        v-model="filtroProductosComparados.page"        
        class="float-right"      
        :current-page="filtroProductosComparados.page"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="filtroProductosComparados.perPage"
        layout="total,sizes,prev,pager,next"
        :total="total.productosComparados"
    >
    </el-pagination>
    <br />
  </div>
</template>
<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import BuscadorProductosVue from '../../empresa/contratista/BuscadorProductos.vue';

export default {
    name: 'generarMatriz',
    data() {
        return {
            columnas: [
                {
                    key: "nombre",
                    label: "Nombre",
                    sortable: true,
                    thStyle: {
                        "min-width": "150px !important",
                    },
                },
                {
                    key: "fabricante",
                    label: "Fabricante",
                    sortable: true,
                    thStyle: {
                        "min-width": "150px !important",
                        width: "250px !important",
                    },
                }, 
                {
                    key: "estado",
                    label: "Estado",
                    sortable: true,
                    thStyle: {
                        "min-width": "100px !important",
                        width: "100px !important"
                    }
                },                   
                {
                    key: "opciones",
                    label: "Opciones",
                    thStyle: {
                        "min-width": "110px !important",
                        width: "110px !important",
                    },
                }
            ]
        }
    },
    methods: {
        isChecked(e) {
            
            return false;
        },
        async resetFiltros() {
            this.resetFiltroProductosComparados();
            this.load(true);
            await this.listarProductosComparados();
            this.load(false);
        },
        async buscarProductosComparados() {
            let filtro = {'cantidad': 1, 'tipo':'productosComparados'}
            this.setPage(filtro);
            this.load(true);
            await this.listarProductosComparados();
            this.load(false);
        },
        async setPagePagination(page) {
            let filtro = {'cantidad': page, 'tipo': 'productosComparados'};
            this.load(true);
            this.setPage(filtro);
            await this.listarProductosComparados();
            this.load(false);
        },   
        async setPerPagePagination(perPage) {
            let filtro = {'cantidad': perPage, 'tipo': 'productosComparados'};
            this.load(true);
            this.setPerPage(filtro);
            await this.listarProductosComparados();
            this.load(false);
       },
        async generarMatrizDescargable() {
            this.load(true);

            this.load(false);
        },
        asignarProductoMatriz(producto, checked) {
            let data = {
                'producto': producto,
                'checked': checked
            }

            this.setProductoGenerarMatriz(data);            
        },
        ...mapMutations('dashboard', [
            'load'
        ]),
        ...mapMutations('matrizCompatibilidad', [
            'setPerPage',
            'setPage',
            'resetFiltroProductosComparados',
            'setProductoGenerarMatriz'
        ]),
        ...mapActions('matrizCompatibilidad', [
            'listarProductosComparados'
        ])
    },
    computed: {
        ...mapState('matrizCompatibilidad', [
            'productosComparados',
            'filtroProductosComparados',
            'productosGenerarMatriz',
            'total'
        ]),
        ...mapState('productos', [
            'fabricantes',
            'estados'
        ])
    }
}
</script>

<style>

</style>